var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"prompt"}},[(_vm.active)?_c('div',{ref:"prompt",staticClass:"chart-prompt",style:(_vm.positionStyle)},[_c(_vm.viewComponent,{tag:"component",attrs:{"data":_vm.data}}),_c('cross-button',{staticClass:"chart-prompt__cross-btn",attrs:{"color":"grey"},on:{"click":_vm.onClose}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }